<script>
import Layout from "../../layouts/auth";
import { mapState } from "vuex";
import $api from "@/state/api";

import appConfig from "@/app.config";
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import Swal from "sweetalert2";
// import $cookies from "vue-cookies";
import { mapActions } from "vuex/dist/vuex.cjs.js";
/**
 * Login component
 */
export default {
	setup() {
		return { v$: useVuelidate() };
	},
	page: {
		title: "Login",
		meta: [
			{
				name: "description",
				content: appConfig.description,
			},
		],
	},
	components: {
		Layout,
	},
	data() {
		return {
			username: "",
			password: "",
			credentials: {
				username: "admin",
				password: "password",
			},
			submitted: false,
			authError: null,
			tryingToLogIn: false,
			isAuthError: false,
			showPassword: false,
		};
	},
	validations: {
		username: {
			required: helpers.withMessage("Username is required", required),
		},
		password: {
			required: helpers.withMessage("Password is required", required),
		},
	},
	computed: {
		...mapState("authfack", ["status"]),
		notification() {
			return this.$store ? this.$store.state.notification : null;
		},
	},
	methods: {
		...mapActions("auth", {
			authLogin: "loginUser",
		}),
		toggleShow() {
			this.showPassword = !this.showPassword;
		},
		async login() {
			if (!this.credentials) {
				Swal.fire("Failed!", 'Please Input Username', "");
				return;
			}
			if (!this.password) {
				Swal.fire("Failed!", 'Please Input Password', "");
				return;
			}
			this.loading = true;
			var loginUser = await this.authLogin({
				username: this.username,
				password: this.password,
			});
			console.log(loginUser);
			// if (loginUser.message == 'Please verify your OTP') {
			// 	this.user_id = loginUser.data.user_id;
			// 	this.showOtp = true;
			// }
			this.loading = false;
		},
	},
	mounted() {
		$api.resetSessionAlert();
	},
};
</script>

<template>
	<Layout>
		<div class="row justify-content-center">
			<div class="col-md-8 col-lg-6 col-xl-5">
				<div class="bg-white overflow-hidden radius-10 border glow">
					<div class="bg-soft theme-color">
						<div class="row">
							<div class="col-7">
								<div class="text-white p-4">
									<h5 class="text-white fw-bolder">WELCOME !</h5>
									<p>Sign in to continue to <br>
										<strong>GAPP</strong>
									</p>
								</div>
							</div>
							<div class="col-5 align-self-end">
								<img src="@/assets/images/gapplogo.png" height="30" alt class="img-fluid" />
							</div>
						</div>
					</div>
					<div class="card-body pt-0 mt-4">
						<b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{ authError
							}}</b-alert>
						<div v-if="notification.message" :class="'alert ' + notification.type">
							{{ notification.message }}
						</div>

						<b-form class="p-2" @submit.prevent="login">
							<b-form-group class="mb-3" id="input-group-1">
								<!-- <b-form-input id="input-1" v-model="username" type="text" placeholder="Enter username"
									:class="{
										'is-invalid':
											submitted && v$.username.$error,
									}"></b-form-input> -->
								<div class="login__field">
									<i class="login__icon fas fa-user"></i>
									<b-form-input type="text" id="input-1" v-model="username" class="login__input"
										placeholder="User name / Email" :class="{
											'is-invalid':
												submitted && v$.username.$error,
										}"></b-form-input>
									<div v-for="(item, index) in v$.username.$errors" :key="index"
										class="invalid-feedback">
										<span v-if="item.$message">{{
											item.$message
										}}</span>
									</div>
								</div>

							</b-form-group>
							<b-form-group class="mb-3" id="input-group-2">
								<!-- <b-form-input id="input-2" v-model="password" type="password"
									placeholder="Enter password" :class="{
										'is-invalid':
											submitted && v$.password.$error,
									}"></b-form-input> -->
								<div class="login__field">
									<i class="login__icon fas fa-lock"></i>
									<div class="d-flex">
										<b-form-input  :type="showPassword ? 'text':'password'" id="input-2" v-model="password" class="login__input"
											placeholder="Password" :class="{
												'is-invalid':
													submitted && v$.password.$error,
											}"></b-form-input>
										<i @click="toggleShow" class="eye-btn">
											<span class="icon is-small is-right">
												<i class="fas"
													:class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"></i>
											</span>
										</i>
									</div>
									<div v-if="submitted && v$.password.$error" class="invalid-feedback">
										<span v-if="v$.password.required.$message">{{
											v$.password.required.$message
										}}</span>
									</div>
								</div>

							</b-form-group>
							<div class="mt-4 d-grid">
								<button type="submit" class="btn-block btn theme-color text-white theme-color-hover">Log
									In</button>
							</div>
						</b-form>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
<style scoped>
.eye-width {
	border-radius: 0px !important;
}
.eye-btn {
	background-color: transparent;
	border: none;
	color: rgb(109, 109, 109) !important;
	border-radius: 0px !important;
	position: absolute;
	cursor: pointer;
	right: 10px;
	top: 32px;
}
</style>